import { render, staticRenderFns } from "./WorkClientAddressTableItem.vue?vue&type=template&id=5519cc86&scoped=true&"
import script from "./WorkClientAddressTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkClientAddressTableItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientAddressTableItem.vue?vue&type=style&index=0&id=5519cc86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5519cc86",
  null
  
)

export default component.exports